@if (ultimateOwnership$ | async; as ultimateOwnership) {
  <h6 class="mb-0 font-weight-bold">
    @if (company$ | async; as company) {
      <span>
        {{ 'screening.screening_overrides.suggestions.ownership.title' | translate: { companyName: company.name } }}
      </span>
    } @else {
      <span>
        {{ 'screening.screening_overrides.suggestions.ownership.title_no_company' | translate }}
      </span>
    }
    <nk-help-popover [popoverTemplate]="tipPopoverTemplate"></nk-help-popover>
  </h6>
  @if (ultimateOwnership.elements.length > 0) {
    <table class="table table-dense table-striped w-100">
      <thead>
        <tr class="sm text-muted">
          <th>
            {{ 'screening.screening_overrides.suggestions.ownership.company' | translate }}
          </th>
          <th>
            {{ 'screening.screening_overrides.suggestions.ownership.percentage' | translate }}
          </th>
          <th>{{ 'screening.screening_overrides.suggestions.ownership.year' | translate }}</th>
        </tr>
      </thead>
      <tbody class="small">
        @for (element of ultimateOwnership.elements; track element.company_share_ownership_ultimate.uuid) {
          <tr>
            <td [class.font-weight-bold]="element.isConnected">{{ element.company.name | prettyCompanyName }}</td>
            <td>{{ element.company_share_ownership_ultimate.ownership | percentage }}</td>
            <td>{{ element.company_share_ownership_ultimate.year }}</td>
          </tr>
        }
        @if (ultimateOwnership.elements.length > ultimateOwnership.count) {
          <tr>
            <td>
              @let personMasterUuid = inputData()?.person_master_uuid;
              @if (personMasterUuid) {
                <a class="text-capitalize" [routerLink]="'/person/' + personMasterUuid">
                  {{ 'screening.screening_overrides.suggestions.see_more' | translate }}
                </a>
              }
            </td>
            <td></td>
            <td></td>
          </tr>
        }
      </tbody>
    </table>
    <hr />
  } @else {
    @if (!isLoading() && ultimateOwnership.count === 0) {
      <span class="text-muted small">{{
        'screening.screening_overrides.suggestions.ownership.no_ownership_found' | translate
      }}</span>
      <hr />
    }
  }
}

<ng-template #tipPopoverTemplate>
  <p class="mb-0">
    {{ 'screening.screening_overrides.suggestions.ownership.help_text' | translate }}
  </p>
  <p class="mb-0 mt-2">
    <strong>{{ 'screening.screening_overrides.suggestions.ownership.help_bold_text' | translate }}</strong>
    {{ 'screening.screening_overrides.suggestions.ownership.help_bold_description' | translate }}
  </p>
</ng-template>
